module.exports = __webpack_public_path__ + "img/tatsing-global-trading-logo.c991a5a3.png";